import Vue from 'vue'
import App from './App.vue'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './sass/main.scss'

import 'swiper/components/effect-coverflow/effect-coverflow.min.css'
import 'swiper/swiper-bundle.min.css'
import VueAwesomeSwiper from 'vue-awesome-swiper';
import { Swiper, EffectCoverflow } from 'swiper'

Swiper.use([EffectCoverflow]);
Vue.use(VueAwesomeSwiper);


Vue.use(BootstrapVue)

Vue.use(IconsPlugin)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
